import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { Spinner } from '@/components/ui/spinner'
import { useAuthContext } from '@/contexts/auth-context'

type PrivateRouteProps = React.PropsWithChildren

export const PrivateRoute = ({ children }: PrivateRouteProps) => {
  const { authenticated, isLoading } = useAuthContext()
  const navigate = useNavigate()

  useEffect(() => {
    if (isLoading || authenticated) return

    navigate('/auth/login')
  }, [authenticated, isLoading, navigate])

  if (authenticated) {
    return children
  }

  return (
    <div className="grid min-h-screen place-content-center">
      <Spinner />
    </div>
  )
}
